import React, { useEffect } from 'react'
import { Route, Switch, useLocation } from 'react-router'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import jwtDecode from 'jwt-decode'

import Home from '../pages/home'
import LoginPage from '../pages/login'
import DeviceManagement from '../pages/device-management/device-management'
import AssetManagement from '../pages/asset-management/asset-management'
import ProductSelect from '../pages/product-select/product-select'
import DeviceTemplate from '../pages/device-configuration/device-configuration'
import TankHome from '../components/tank/home'
import ContentLoader from '../components/content-loader/content-loader'
import { history } from '../redux/store'
import { setAuthUser, setUserEmail, setUserRole } from '../redux/actions/auth'
import DevicesProvision from '../pages/device-provision'
import CustomerManagement from '../components/customers/actions/customer-management/customer-management'
import FacilityManagement from '../components/facility/facility-managment/facility-management'
import TankDevicesProvision from '../components/tank/pages/tank-device-provision'
import TankDeviceManagement from '../components/tank/device-management/device-management'
import AlertManagement from '../components/tank/alert-management/alert-management'
import AlertView from '../components/alert-mgmt/alert-view'

const Routes = () => (
  <Switch>
    <Route path="/login" component={LoginPage} />
    <RestrictedRoute path="/template" component={DeviceTemplate} />
    <RestrictedRoute path="/product" component={ProductSelect} />
    <RestrictedRoute path="/device/management" component={DeviceManagement} />
    <RestrictedRoute path="/asset/management" component={AssetManagement} />
    <RestrictedRoute
      path="/facility/management"
      component={FacilityManagement}
    />
    <RestrictedRoute path="/device/provision" component={DevicesProvision} />
    <RestrictedRoute
      path="/company/management"
      component={CustomerManagement}
    />
    <RestrictedRoute path="/alert/management" component={AlertView} />
    <RestrictedRoute
      path="/Tank/device/provision"
      component={TankDevicesProvision}
    />
    <RestrictedRoute
      path="/Tank/company/management"
      component={CustomerManagement}
    />

    <RestrictedRoute
      path="/Tank/device/management"
      component={TankDeviceManagement}
    />
    <RestrictedRoute
      path="/Tank/alert/management"
      component={AlertManagement}
    />

    <RestrictedRoute
      path="/hierarchy/management"
      component={CustomerManagement}
      // eslint-disable-next-line react/jsx-boolean-value
      props={{ fromHierarchy: true }}
    />
    <RestrictedRoute path="/cold" component={Home} />

    <RestrictedRoute path="/Tank" component={TankHome} />
    <Route component={LoginPage} />
  </Switch>
)

const RestrictedRoute = ({ component: Component, props }) => {
  const isAuthUser = useSelector((store) => store.auth.authUser)
  const productName = useSelector((store) => store.product.productName)
  const location = useLocation()
  const dispatch = useDispatch()

  useEffect(() => {
    if (
      isAuthUser &&
      productName == null &&
      (location.pathname !== '/login' || location.pathname !== '/product')
    ) {
      history.push('/product')
    }
  }, [])

  useEffect(() => {
    if (!isAuthUser) {
      const token = localStorage.getItem('token')

      if (token) {
        const decoded = jwtDecode(token)
        dispatch(setAuthUser(true))
        dispatch(setUserRole(decoded.role))
        dispatch(setUserEmail(decoded.sub))
      } else {
        history.push('/login')
      }
    }
  }, [isAuthUser])

  return (
    <Route
      {...props}
      render={() => (isAuthUser ? <Component {...props} /> : <ContentLoader />)}
    />
  )
}

RestrictedRoute.propTypes = {
  component: PropTypes.any.isRequired,
  props: PropTypes.any.isRequired,
}
export default Routes
